import React from 'react';
import ReactDOM from 'react-dom';
import c from 'classnames';
import { loaderContainer, darkLoader } from './style';

function DarkLoader({ size = 'large', className }) {
  return (
    <div className={c(className, darkLoader, size)}>
      <span className="yellow" />
      <span className="blue" />
      <span className="green" />
    </div>
  );
}

class DarkLoaderFullScreen extends React.Component {
  render() {
    const { className, children } = this.props;
    return (
      <div className={c(loaderContainer, className)}>
        <DarkLoader />
        {children}
      </div>
    );
  }
}
class DarkThemedLoader extends React.Component {
  state = {
    count: 0
  };

  showLoader = () => {
    this.setState(prevState => ({
      count: prevState.count + 1
    }));
  };

  hideLoader = () => {
    this.setState(prevState => ({
      count: prevState.count - 1
    }));
  };

  render() {
    const { count } = this.state;
    return count > 0 ? (
      <div className={loaderContainer}>
        <DarkLoader />
      </div>
    ) : null;
  }
}

const el = document.createElement('div');
document.body.appendChild(el);

// eslint-disable-next-line react/no-render-return-value
const { showLoader, hideLoader } = ReactDOM.render(<DarkThemedLoader />, el);

export { showLoader, hideLoader, DarkLoaderFullScreen };

export default DarkLoader;
